import { IterableElement } from 'type-fest'
import { BASE_TOKEN_TICKERS } from './token-tickers'

import { Ticker } from '../ticker'

export const BASE_TICKERS = [Ticker.ETH, ...BASE_TOKEN_TICKERS]

export type BaseTicker = IterableElement<typeof BASE_TICKERS>
